import { IShiftType } from "~/api";
import { IShift } from "~/routes/api/types";

export const eligibleToWork = (shiftType: IShiftType | IShift) =>
  shiftType.isPatientCareShift === false &&
  shiftType.isWorkingShift === false &&
  shiftType.isPaidShift === false &&
  shiftType.key !== "approvedTimeOff";
